import { type SvgComponentType } from "@newsela/angelou";

import {
  ESSENTIALS_MENU_ITEM,
  ProductLicenseKeysEnum,
  SUBJECT_AREA_ITEMS,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { SubjectItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectItems/SubjectItem/SubjectItem";
import { productVisibilityBreakpointCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectItems/SubjectItems.styles";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";
import { useNavBarItemVisibility } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useNavBarItemsVisibilityControl";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

const SubjectItems = () => {
  const {
    isStudent,
    isAuthenticatedUser,
    activeSSLicense,
    activeELALicense,
    activeScienceLicense,
    activeEssentialsLicense,
    activeStemLicense,
    canViewSearch,
  } = useGetUserProperties();

  const [showLockIconsExperiment] =
    useGetUserExperimentSegment("show_lock_icons");

  const showLicenseItemWithLock = showLockIconsExperiment === "on";
  const { isVisible } = useNavBarItemVisibility();

  if (!isAuthenticatedUser || !canViewSearch) return null;

  const licensesMap = {
    [ProductLicenseKeysEnum.SS]: activeSSLicense,
    [ProductLicenseKeysEnum.ELA]: activeELALicense,
    [ProductLicenseKeysEnum.SCI]: activeScienceLicense,
    [ProductLicenseKeysEnum.STEM]: activeStemLicense,
  };

  return (
    <>
      {activeEssentialsLicense && (
        <li css={productVisibilityBreakpointCss(isVisible("subject-items"))}>
          <SubjectItem
            href={ESSENTIALS_MENU_ITEM.href}
            title={ESSENTIALS_MENU_ITEM.title}
            SvgComponent={ESSENTIALS_MENU_ITEM.SvgComponent as SvgComponentType}
            locked={false}
            dataQASelector={ESSENTIALS_MENU_ITEM.dataQASelector}
          />
        </li>
      )}
      {SUBJECT_AREA_ITEMS.filter(({ license }) => {
        const isStem = license === ProductLicenseKeysEnum.STEM;
        const isScience = license === ProductLicenseKeysEnum.SCI;

        if (isStem) {
          return activeStemLicense;
        }

        if (isScience) {
          return (
            (activeScienceLicense || (showLicenseItemWithLock && !isStudent)) &&
            !activeStemLicense
          );
        }

        // All other subjects
        return licensesMap[license] || (showLicenseItemWithLock && !isStudent);
      }).map(
        ({ title, href, license, SvgComponent, dataQASelector }, index) => (
          <li
            key={index}
            css={productVisibilityBreakpointCss(isVisible("subject-items"))}
          >
            <SubjectItem
              href={href}
              title={title}
              SvgComponent={SvgComponent as SvgComponentType}
              locked={!licensesMap[license]}
              dataQASelector={dataQASelector}
            />
          </li>
        ),
      )}
    </>
  );
};

SubjectItems.displayName = "SubjectItems";
export { SubjectItems };
